import styled from 'styled-components'

import { useProgressReportJobs } from '../../contexts/progressReportJobsContext'
import { useUserContext } from '../../contexts/userContext'

const Banner = styled.span`
  font-size: 13px;
  color: #5c6f8a;
  max-width: 360px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export function ProgressReportJobBanner() {
  const { pendingJobs, jobStatusById } = useProgressReportJobs()
  const { state } = useUserContext()
  if (state.user_type !== 'super' || pendingJobs.length === 0) {
    return null
  }
  const text =
    pendingJobs.length === 1
      ? (() => {
          const job = pendingJobs[0]
          const st = jobStatusById[job.jobId]
          if (st === 'pending') {
            return `Progress report queued (${job.projectName})…`
          }
          if (st === 'running') {
            return `Progress report generating on the server (${job.projectName})…`
          }
          return `Progress report in progress (${job.projectName})…`
        })()
      : `${pendingJobs.length} progress reports in progress…`
  return (
    <Banner title={text} role="status" aria-live="polite">
      {text}
    </Banner>
  )
}
